<template>
  <div id="box">
    <img src="../assets/images/logo.png" alt />
    <div class="box_1">
      <h2>会议预约后台</h2>
      <p class="box_p">账号</p>
      <br />
      <el-input class="input1" placeholder="输入账号" v-model="input"></el-input>
      <br />
      <p class="box_p1">密码</p>
      <br />
      <el-input class="input2" type="password" placeholder="输入密码" v-model="input1"></el-input>

      <button @click="loginpost()">登录</button>
      <!-- <router-link to="/index">
        跳转
      </router-link>-->
    </div>
    <h3>会议预约后台</h3>
    <p>智能会议预约系统,便利办公室信息化管理</p>
    <div class="box_0"></div>
  </div>
</template>

<script>
// import index from './index.vue'
// import index from '/pages/index';
// import axios from 'axios';

export default {
  // name:index,
  // components: {
  //   index
  // },
  data() {
    return {
      input: "",
      input1: ""
    };
  },
  methods: {
    //
    //post请求
    loginpost() {
      var sha512 = require("js-sha512").sha512;
      if (this.input != "" && this.input1 != "") {
        console.log(this);
        this.$axios
          .post(
            `https://meeting.joncloudapp.com/api/customer/h5Login?account=${
              this.input
            }&password=${sha512(this.input + this.input1)}`
          )
          .then(res => {
            let data = res.data;
            if (data.code == 200) {
              // console.log(data.data.user)
              // var name = data.data.user.username
              // localStorage.setItem('key',name); //将变量imgs存储到name字段

              // var id = data.data.user.userId //声明个变量存储下数据
              // console.log(data.data.id,'idididi')
              //  localStorage.setItem('keyid',id);
              window.sessionStorage.setItem("account", this.input);
              window.sessionStorage.setItem("token", data.data.token);
              window.sessionStorage.setItem("userName", data.data.user.company);
              window.sessionStorage.setItem(
                "roomCount",
                data.data.user.roomCount
              );

              this.$message({
                type: "success",
                message: res.data.message
              });
              this.$router.push({
                path: "./index"
              });
            }
            if (data.code == 500) {
              this.$message.error(data.message);
            }
            if (data.code == 1001) {
              this.$message.error(data.message);
              // alert(data.message);
            }
          });
      } else {
        this.$message.error("账号密码不能为空！");
      }
    },

    objKeySort(obj) {
      //排序的函数
      var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      var newObj = ""; //创建一个新的字符串，用于存放排好序的键值对
      for (var i = 0; i < newkey.length; i++) {
        //遍历newkey数组
        obj[newkey[i]] = JSON.stringify(obj[newkey[i]]);
        //向新创建的对象中按照排好的顺序依次增加键值对
        newObj +=
          (newObj.indexOf("=") != -1 ? "&" : "") +
          newkey[i] +
          "=" +
          obj[newkey[i]];
      }
      return newObj; //返回排好序的
    },

    aaa() {
      //get请求
      // this.$axios
      //   .get("http://192.168.1.145:8887/api/Login/login",
      //     {
      //     username:this.input,
      //     password:this.input1
      //   })
      //   .then(res => {
      //     console.log(res,'11111111')
      //     let data = res.data;
      //     console.log(data, "哈哈");
      //   });
      // this.$router.push({
      //   path: "./index"
      // });
    }
  },
  // 请求数据
  beforeMount() {}
};
</script>
<style>
el-input {
  background-color: #fff;
}
body {
  box-sizing: border-box;
  /* margin:0; padding:0; */
  /* overflow-y: hidden; */
}
.input1 .el-input__inner {
  width: 335px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  padding: 0;
  background: #fff;
}
.input2 .el-input__inner {
  width: 335px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  padding: 0;
  margin-bottom: 38px;
}
</style>

<style scoped lang="scss">
#box {
  overflow-y: hidden;
  width: 100%;
  height: 800px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  background: url(../assets/images/bg.png);
  img {
    position: absolute;
    top: 71px;
    left: 146px;
    z-index: 999;
  }
  h3 {
    width: 252px;
    height: 59px;
    font-size: 42px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 59px;
    position: absolute;
    top: 362px;
    left: 177px;
    z-index: 99;
  }
  p {
    width: 552px;
    height: 42px;
    font-size: 30px;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 42px;
    position: absolute;
    top: 429px;
    left: 177px;
    z-index: 99;
  }
  .box_1 {
    width: 435px;
    height: 698px;
    background: #fff;
    box-shadow: 0px 2px 34px 0px rgba(0, 0, 0, 0.07);
    border: 1px solid rgba(243, 243, 243, 1);
    z-index: 999;
    position: relative;
    position: absolute;
    top: 36px;
    right: 36px;
    .input1 {
      position: absolute;
      top: 306px;
      left: 50px;
    }
    .input2 {
      position: absolute;
      top: 385px;
      left: 50px;
    }
    h2 {
      width: 156px;
      height: 37px;
      font-size: 26px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 37px;
      position: absolute;
      top: 162px;
      left: 50px;
    }
    .box_p {
      position: absolute;
      top: 284px;
      left: 50px;
    }
    .box_p1 {
      position: absolute;
      top: 366px;
      left: 50px;
    }
    p {
      width: 30px;
      height: 21px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(39, 49, 66, 1);
      line-height: 21px;
    }
    button {
      width: 335px;
      height: 48px;
      font-size: 17px;
      color: rgba(255, 255, 255, 1);
      background: rgba(4, 195, 255, 1);
      border-radius: 6px;
      position: absolute;
      top: 449px;
      left: 50px;
    }
  }
  .box_0 {
    box-sizing: border-box;
    width: 1370px;
    height: 700px;
    background: rgba(4, 195, 255, 1);
    opacity: 0.5;
    position: absolute;
    top: 36px;
    right: 36px;
  }
}
</style>